import { Controller } from "stimulus"

export default class extends Controller {
  updateConfiguration(event) {
    let form = event.target.closest('form');
    form.action = window.location;
    form.method = 'GET';
    form.submit();
  }
}
